import React, { Component, Fragment } from "react";
import { Carousel } from "react-bootstrap";
import { LoadingSpinner } from "../LoadingSpinner";
import { TrainsSection } from "../TrainStops/TrainsSection";
import { TrainsSectionHeader } from "../TrainStops/TrainsSectionHeader";
import { TrainsSectionTitle } from "./TrainsSectionTitle";
import { SosInfo } from "./Facilities/SosInfo";
import { DisabledFacilities } from "./Facilities/DisabledFacilities";
// import { CityBike } from "./Facilities/CityBike";

import bus from "../Images/Icons/bus.png";
import convenience from "../Images/Icons/convenience.png";
import communication from "../Images/Icons/communication.png";
import zdj1 from "../Images/Stops/Niedzwiednik/pkm-niedz1.jpg";
import zdj2 from "../Images/Stops/Niedzwiednik/pkm-niedz2.jpg";
import zdj3 from "../Images/Stops/Niedzwiednik/pkm-niedz3.jpg";
import downloadIcon from "../Images/Icons/download.png";
// import WarningMessage from "./Warning";



class Niedzwiednik extends Component {
  state = {
    citytransport: [],
    trains: [],
    bikes: [],
    loadingTrains: false
  };

  fetchData() {
    fetch("/przystanki/api/pkm.php?przystanek=257534")
      .then(res => res.json())
      .then(data =>
        this.setState({
          ...this.state,
          trains: data
        })
      )
      .catch(error =>
        this.setState({
          loadingTrains: true
        })
      );

    // fetch(
    //   "/przystanki/api/mevo.php?przystanek=p_niedzwiednik"
    // )
    //   .then(res => res.json())
    //   .then(data =>
    //     this.setState({
    //       ...this.state,
    //       bikes: data[1]
    //     })
    //   );
  }

  componentDidMount() {
    this.fetchData();
    this.interval = setInterval(() => this.fetchData(), 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    var trainsThatStop = this.state.trains.slice(0, 10).filter(function(train) {
      return train.isStopping;
    });

    return (
      <Fragment>
        <div className="general">
          <div className="transtop-name d-flex justify-content-between">
            <span className="stop-name">Gdańsk Niedźwiednik</span>
            <a
              href="/przystanki/timetables/GdanskNiedzwiednik.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="timetable-download d-flex align-items-center"
            >
              Pobierz cały rozkład jazdy dla tego przystanku
              <img
                className="timetable-download__icon"
                src={downloadIcon}
                alt="download icon"
              />
            </a>
          </div>
          {/* <WarningMessage /> */}
          <section className="timetable-section">
            <TrainsSectionTitle />
            <div className="timetable-container">
              <table className="timetable">
                <TrainsSectionHeader />
                {this.state.loadingTrains ? (
                  <LoadingSpinner />
                ) : (
                  <TrainsSection trains={trainsThatStop} />
                )}
              </table>
            </div>
          </section>
          <section className="additional-information-section">
            <Carousel
              indicators={false}
              controls={false}
              className="trainstops-images"
            >
              <Carousel.Item>
                <img
                  className="d-block w-100 trainstop-single-image"
                  src={zdj1}
                  alt="Niedźwiednik zdj1"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 trainstop-single-image"
                  src={zdj2}
                  alt="Niedźwiednik zdj2"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100 trainstop-single-image"
                  src={zdj3}
                  alt="Niedźwiednik zdj3"
                />
              </Carousel.Item>
            </Carousel>
            <div className="trainstop-header">
              <img
                className="trainstop-header__icon"
                src={convenience}
                alt="convenience-icon"
              />
              Udogodnienia
            </div>
            <div className="convenience-container">
              {/* <CityBike bikes={this.state.bikes} /> */}
              <div className="convenience-item d-flex align-items-center">
                <div className="convenience-symbol__container d-flex align-items-center">
                  <img
                    className="convenience-symbol"
                    src={communication}
                    alt="public transport"
                  />
                </div>
                <div className="convenience-symbol__value d-flex align-items-center">
                  <img src={bus} alt="bus" />
                </div>
                <div className="convenience-symbol__description">
                  Transport publiczny
                </div>
              </div>
              <DisabledFacilities />
              <SosInfo />
            </div>
          </section>
        </div>
      </Fragment>
    );
  }
}

export default Niedzwiednik;
